import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Bed, Bath, Square } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { formatPrice } from "../lib/api";

const PropertyCard = ({ property, index = 0 }) => {
  const { lang, t } = useLang();
  const title = lang === "it" ? property.title_it : property.title_en;
  const isArchived = property.status === "sold" || property.status === "rented";

  return (
    <Link
      to={`/immobili/${property.slug || property.id}`}
      data-testid={`property-card-${property.slug}`}
      className={`group block bg-white rounded-2xl overflow-hidden border border-[#E8DFD8] hover:shadow-xl hover:-translate-y-1 transition-all duration-300 fade-up ${isArchived ? "opacity-90" : ""}`}
      style={{ animationDelay: `${index * 80}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-[#F3E6DA]">
        <img
          src={property.images?.[0]}
          alt={title}
          loading="lazy"
          className={`w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ${isArchived ? "grayscale-[60%]" : ""}`}
        />
        {isArchived && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="bg-[#2C2621]/85 text-white font-display text-2xl px-8 py-3 rounded-full uppercase tracking-[0.2em] rotate-[-6deg] border-2 border-white/40">
              {property.status === "sold" ? t.property.sold : t.property.rented}
            </div>
          </div>
        )}
        <div className="absolute top-4 left-4 flex gap-2">
          {!isArchived && (
            <span className="bg-white/95 backdrop-blur text-[#8B5A3C] text-[11px] font-bold uppercase tracking-[0.18em] px-3 py-1.5 rounded-full">
              {property.contract === "sale" ? t.property.forSale : t.property.forRent}
            </span>
          )}
        </div>
        <div className="absolute bottom-4 right-4 bg-[#2C2621]/85 backdrop-blur text-white text-sm font-display font-semibold px-3.5 py-1.5 rounded-full">
          {formatPrice(property.price, property.contract, lang)}
        </div>
      </div>
      <div className="p-6">
        <div className="flex items-center gap-1.5 text-[#8A8178] text-xs mb-2">
          <MapPin size={13} />
          <span>{property.zone}, {property.city}</span>
        </div>
        <h3 className="font-display text-xl font-medium text-[#2C2621] leading-snug line-clamp-2 mb-4 group-hover:text-[#8B5A3C] transition-colors">
          {title}
        </h3>
        <div className="flex items-center gap-5 text-sm text-[#5C544B] pt-4 border-t border-[#E8DFD8]">
          <span className="flex items-center gap-1.5"><Bed size={15} className="text-[#8B5A3C]" />{property.bedrooms}</span>
          <span className="flex items-center gap-1.5"><Bath size={15} className="text-[#8B5A3C]" />{property.bathrooms}</span>
          <span className="flex items-center gap-1.5"><Square size={15} className="text-[#8B5A3C]" />{property.area_sqm} m²</span>
        </div>
      </div>
    </Link>
  );
};

export default PropertyCard;
